import React, { useContext } from 'react';
import { UserContext } from 'contexts/user/UserContext';
import ChatRedirect from './ChatRedirect';  // Discourse redirect
import ChatFullscreen from './ChatFullscreen';  // Stream Chat

const ChatRouter: React.FC = () => {
  const { currentUser } = useContext(UserContext);
  if (currentUser === null || currentUser === undefined) {
    return null;
  }

  const discourseUrl = import.meta.env.VITE_DISCOURSE_URL as string || '';
  const isDiscourseStealthModeEnabled = import.meta.env.VITE_DISCOURSE_STEALTH === 'true';
  if ((!isDiscourseStealthModeEnabled || currentUser?.isAdmin || currentUser?.isForumAdmin) && discourseUrl) {
    return <ChatRedirect />;
  }

  return <ChatFullscreen />;
};

export default ChatRouter;
